import { render, staticRenderFns } from "./StudyMaterial.vue?vue&type=template&id=14fc251c&scoped=true&"
import script from "./StudyMaterial.vue?vue&type=script&lang=js&"
export * from "./StudyMaterial.vue?vue&type=script&lang=js&"
import style0 from "./StudyMaterial.vue?vue&type=style&index=0&id=14fc251c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc251c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDataTable,VSpacer,VTextField,VToolbar})
